
import React from 'react'
import { mdx } from '@mdx-js/react'

/* @jsx mdx */
import {Link} from 'contentbricks'
import { M, I } from './_elements.tsx'

const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope")
  return <div {...props}/>
};

const layoutProps = {
  
};
const MDXLayout = "wrapper"
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">

    <p>{`Wie schön wäre es, wenn wir uns während der Ferien oder vor einer strengen Woche einige Energiereserven «anschlafen» könnten. `}<M mdxType="M">{`Doch Schlafforscher sind sich einig: Vorschlafen bringt nichts.`}</M>{` Da die meisten Menschen tagsüber oder am frühen Abend versuchen, in kurzen Phasen auf Vorrat zu schlafen, fehlt meist der Tiefschlaf, der für die Erholung wichtig ist. Und auch wenn der Schlaf erholsam sein sollte: Der Körper kann diese vorgängige Erholung nicht abspeichern und zu einem beliebigen späteren Zeitpunkt nutzen. Der Biologe Till Roenneberg zeichnete in einem `}<Link href='https://www.sueddeutsche.de/muenchen/spaetes-wm-finale-warum-vorschlafen-wenig-bringt-1.2038316' mdxType="Link">{`Interview mit der «Süddeutschen Zeitung»`}</Link>{` ein eingängiges Bild: Schlaf ist wie ein Kreditkonto, auf dem man kein Guthaben anhäufen kann. Man kann es entweder auf null setzen, indem man ausreichend schläft, oder neue Schulden anhäufen, indem man zu wenig schläft.`}</p>
    </MDXLayout>;
}

;
MDXContent.isMDXComponent = true;